import { UniswapV3AbstractTrade } from '../../common/uniswap-v3-abstract/uniswap-v3-abstract-trade';

export class UniSwapV3ScrollSepoliaTrade extends UniswapV3AbstractTrade {
    public readonly dexContractAddress = '0x59a662Ed724F19AD019307126CbEBdcF4b57d6B1';
}
